import { render, staticRenderFns } from "./PFormCheckBoxMulti.vue?vue&type=template&id=53c6445f&scoped=true&"
import script from "./PFormCheckBoxMulti.vue?vue&type=script&lang=ts&"
export * from "./PFormCheckBoxMulti.vue?vue&type=script&lang=ts&"
import style0 from "./PFormCheckBoxMulti.vue?vue&type=style&index=0&id=53c6445f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6445f",
  null
  
)

export default component.exports